import { combineReducers } from 'redux';
import { RootStateOrAny } from 'react-redux';

import userAuth from '@/redux/ducks/login';
import init from '@/redux/ducks/init';
import transactions from '@/redux/ducks/transaction';
import manageQR from '@/redux/ducks/manageQR';
import merchantProfile from '@/redux/ducks/merchantProfile';
import reportList from '@/redux/ducks/report';
import transactionDetail from '@/redux/ducks/trasnasctionDetail';
import toast from '@/redux/ducks/toast';
import refunds from '@/redux/ducks/refunds';
import bulkRefunds from '@/redux/ducks/bulkRefunds';
import refundReports from '@/redux/ducks/refundReports';
import store from '@/redux/ducks/manageStores';
import dailyReport from '@/redux/ducks/dailyReport';
import chatBot from '@/redux/ducks/chatBot';
import userProfile from '@/redux/ducks/userProfile';
import notifications from '@/redux/ducks/notifications';
import userConfig from '@/redux/ducks/userConfig/reducer';
import { INIT_APP_ERROR } from '@/redux/ducks/init/types';
import MoReducers from '@/online-merchant-onboarding/redux/ducks';

const reducer = combineReducers({
	init,
	userAuth,
	transactions,
	manageQR,
	merchantProfile,
	reportList,
	transactionDetail,
	toast,
	refunds,
	bulkRefunds,
	refundReports,
	store,
	dailyReport,
	chatBot,
	userProfile,
	userConfig,
	notifications,
	...MoReducers,
});

const rootReducer = (state: RootStateOrAny, action: { type: string }) => {
	if (action.type === INIT_APP_ERROR) {
		return reducer(undefined, action);
	}
	return reducer(state, action);
};

export type RootState = ReturnType<typeof rootReducer>;
export default rootReducer;
